import { millingNameFromFile } from "./millingDefaults";

const normalized = value => value.normalize("NFD").replace(/\p{M}/gu, "").toLowerCase().trim();
const presets = {
  rama: { name: "Ráma", selectionMode: "manual", maxSizeMm: null },
  fiokelo: { name: "Fiókelő", selectionMode: "height", maxSizeMm: 150 },
  joly: { name: "Joly", selectionMode: "width", maxSizeMm: 150 }
};

// Validate the entire batch before changing any draft files.
export function applyMillingFiles(milling, files) {
  if (!files.length) return milling;
  const groups = new Map();
  let modelName;
  for (const file of files) {
    const match = file.name.match(/^(.*)\.(dxf|png|jpe?g)$/i);
    if (!match) throw new Error(`Nem támogatott fájl: ${file.name}`);
    const isDxf = match[2].toLowerCase() === "dxf";
    if (file.size > (isDxf ? 500 : 10) * 1024 * 1024)
      throw new Error(`Túl nagy fájl: ${file.name} (maximum ${isDxf ? 500 : 10} MB).`);
    const split = match[1].match(/^(.+?)-(.+)$/) || match[1].match(/^(.+?)[_\s]+(standard|standrad|alap|ráma|rama|fiókelő|fiokelo|joly)$/iu);
    if (!split) throw new Error(`Nem azonosítható a változat: ${file.name}. Használd a Marásnév-Standard vagy Marásnév-Változat formát.`);
    const model = millingNameFromFile(split[1]);
    if (!model || (modelName && normalized(modelName) !== normalized(model)))
      throw new Error("Egyszerre egy marás fájljait válaszd ki, azonos marásnévvel.");
    modelName = model;
    const part = split[2].trim();
    const key = ["standard", "standrad", "alap"].includes(normalized(part)) ? "standard" : normalized(part);
    if (!key) throw new Error(`Hiányzó változatnév: ${file.name}`);
    const group = groups.get(key) || { name: part };
    const field = isDxf ? "dxfFile" : "file";
    if (group[field]) throw new Error(`Több ${isDxf ? "DXF" : "kép"} tartozik ehhez: ${part}. Válassz csak egyet.`);
    group[field] = file;
    groups.set(key, group);
  }
  let next = { ...milling, variants: milling.variants.map(v => ({ ...v })) };
  if (!milling.millingId && !milling._nameEdited && !milling.name?.trim()) next.name = modelName;
  for (const [key, { name, ...assets }] of groups) {
    if (key === "standard") { next = { ...next, ...assets }; continue; }
    const existing = next.variants.findIndex(v => normalized(v.name) === key);
    if (existing >= 0) next.variants[existing] = { ...next.variants[existing], ...assets };
    else next.variants.push({ variantId: crypto.randomUUID(), imageKey: "", minSizeMm: null,
      ...(presets[key] || { name, selectionMode: "manual", maxSizeMm: null }), ...assets });
  }
  return next;
}
